import React, { useEffect, useState } from 'react'
import { PHSHeader } from '../../components/UI/header'
import { styles } from './index.sass'
import { DatePicker, Tooltip, message } from 'antd'
import DataTable from '../../components/UI/table'
import moment from 'moment'
import { getEngagementDashboardOverview } from '../../api/engagementDashboard'

export const EngagementDashboard = () => {
  const [loading, setLoading] = useState(false)
  const [rows, setRows] = useState([])
  const [selectedDate, setSelectedDate] = useState({
    start: moment().startOf('month'),
    end: moment().endOf('month')
  })

  const renderObjectCell = (value) => {
    if (!value) return '-'
    const text = typeof value === 'string' ? value : JSON.stringify(value)

    return (
      <Tooltip title={text}>
        <div
          style={{
            maxWidth: 320,
            whiteSpace: 'normal',
            wordBreak: 'break-word',
            lineHeight: 1.4
          }}
        >
          {text}
        </div>
      </Tooltip>
    )
  }

  const columns = [
    { title: 'Client ID', dataIndex: 'client_id', key: 'client_id' },
    { title: 'Client Name', dataIndex: 'client_name', key: 'client_name' },
    {
      title: 'Message from clients',
      dataIndex: 'messages_sent_by_client',
      key: 'messages_sent_by_client',
      render: (value) => renderObjectCell(value)
    },
    {
      title: 'Sessions Allocated',
      key: 'allocated',
      render: (_, row) =>
        row && row.sessions_utilization ? row.sessions_utilization.allocated : 0
    },
    {
      title: 'Sessions Used',
      key: 'used',
      render: (_, row) =>
        row && row.sessions_utilization ? row.sessions_utilization.used : 0
    },
    {
      title: 'Session Breakdown',
      key: 'breakdown',
      render: (_, row) =>
        row && row.sessions_utilization && row.sessions_utilization.breakdown
          ? renderObjectCell(row.sessions_utilization.breakdown)
          : '-'
    },
    {
      title: 'Quarterly Assessments',
      key: 'quarterly_assessments',
      render: (_, row) => {
        const qa = row && row.quarterly_assessments
        if (!qa) return '-'
        return `${qa.completed}/${qa.expected}`
      }
    },
    // {
    //   title: 'Session Utilization Score',
    //   key: 'session_utilization_score',
    //   render: (_, row) =>
    //     row && row.engagement_scores ? row.engagement_scores.session_utilization : '-'
    // },
    // {
    //   title: 'Modality Score',
    //   key: 'modality_score',
    //   render: (_, row) =>
    //     row && row.engagement_scores ? row.engagement_scores.modality_score : '-'
    // },
    // {
    //   title: 'Assessment Score',
    //   key: 'assessment_score',
    //   render: (_, row) =>
    //     row && row.engagement_scores ? row.engagement_scores.assessment_score : '-'
    // }
  ]

  const fetchDashboard = async () => {
    if (!selectedDate.start || !selectedDate.end) return
    setLoading(true)
    try {
      const data = await getEngagementDashboardOverview({
        from_date: selectedDate.start.format('YYYY-MM-DD'),
        to_date: selectedDate.end.format('YYYY-MM-DD')
      })
      setRows(Array.isArray(data) ? data : [])
    } catch (error) {
      message.error('Failed to fetch engagement dashboard data')
      setRows([])
    } finally {
      setLoading(false)
    }
  }

  useEffect(() => {
    fetchDashboard()
  }, [selectedDate.start, selectedDate.end])

  const onChangeDate = (dates) => {
    setSelectedDate({
      start: dates ? dates[0] : null,
      end: dates ? dates[1] : null
    })
  }

  return (
    <div className={styles}>
      <PHSHeader hideBreadCrumb={true} hideSubHeader={true} />
      <div className='container'>
        <h2>Engagement Dashboard</h2>
        <p>Track client engagement metrics, activity trends, and coaching touchpoints in one place.</p>
        <div style={{ margin: '16px 0' }}>
          <DatePicker.RangePicker
            value={[
              selectedDate.start ? moment(selectedDate.start) : null,
              selectedDate.end ? moment(selectedDate.end) : null
            ]}
            onChange={onChangeDate}
            placeholder={['From Date', 'To Date']}
          />
        </div>
        <DataTable
          columns={columns}
          dataSource={rows}
          loading={loading}
          hidePagination={true}
          rowKey='client_id'
        />
      </div>
    </div>
  )
}
